<template>
    <v-container fliud>
        <template>
            <v-btn
                color="primary"
                dark
                @click="check()"
            >
                <v-icon>mdi-check-all</v-icon> Check Forecast
            </v-btn>
        </template>
        <template>
            <v-dialog
                v-model="modal.dialog"
            >
                <v-card>
                    <v-card-title>Forecast Check</v-card-title>
                    <v-card-text>
                        <v-simple-table
                            fixed-header
                            class="gridTable"
                            height="80vh"
                            scrollable>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>SKU</th>
                                        <th v-for="(month, index) in months" :key="index">{{ month }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in filteredProducts" :key="index">
                                        <td>{{ item['Product Name'] }}</td>
                                        <td>{{ item['Style Code'] }}</td>
                                        <td v-for="(month, index2) in months" 
                                            :key="index2"
                                            :class="isForecasted(index2 + 1, item['Style Code'])"
                                            @click="toForecast(index2 + 1, item)"
                                            @contextmenu="show">
                                            <v-menu 
                                                v-model="modal.showMenu"
                                                :position-x="x"
                                                :position-y="y"
                                                absolute
                                                offset-y>
                                                <v-list>
                                                    <v-list-item>
                                                        <v-list-item-title @click="markAsComplete(index2 + 1, item)">Mark as Complete</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template>
            <v-snackbar
                v-model="snackbar"
                :timeout="timeout"
                :color="snackColor"
            >
                {{ snackText}}
                <template v-slot:action="{ attrs }">
                    <v-btn
                        v-bind="attrs"
                        text
                        @click="snackbar = false"
                    >
                        Close
                    </v-btn>
                </template>
            </v-snackbar>
        </template>
    </v-container>
</template>

<script>
export default {
    name: "forecastCheck",
    props: {
        year: {type: Number},
        category: {type: Object},
        forecastQtys: {type: Array},
        products: {type: Array},
    },
    watch: {
        forecastQtys: function() {
            this.forecast = this.$props.forecastQtys.map(function(item) {
                let object = Object.assign({}, item)
                object.Complete = true
                return object
            })
            
        }
    },
    data() {
        return {
            forecast: [],
            modal: {
                dialog: false,
                showMenu: false,
            },
            x: 0,
            y: 0,
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            checkForecastInfo: {
                month: 0,
                product: {},
                refresh: 0,
            },
            snackbar: false,
			snackColor: '',
			snackText: '',
			timeout: 3000,
        }
    },
    methods: {
        check() {
            if (this.$props.Forecast_Name !== 'None Selected') {
                this.modal.dialog = true
            } else {
                this.snack('Select Forecast Category', 'info')
            }
        },
        isForecasted(month, sku) {
            let filter = this.forecast.filter(item => item.Month == month && item.SKU == sku && item.Complete == true)
            if (filter.length > 0) {
                return "completedForecast"
            } else {
                return "incompleteForecast"
            }
        },
        show (e) {
            e.preventDefault()
            this.modal.showMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.$nextTick(() => {
                this.showMenu = true
            })
      },
        markAsComplete(month, product) {
            let item = {}
            item.Month = month
            item.SKU = product['Style Code']
            item.Qty = 0
            this.forecast.push(item)
        },
        toForecast(month, product) {
            this.modal.dialog = false
            this.checkForecastInfo.month = month
            this.checkForecastInfo.product = product
            this.checkForecastInfo.refresh += 1
            console.log(this.checkForecastInfo);
            this.$emit('input', this.checkForecastInfo)
        },
        snack(text, color) {
            this.loading = false
            this.snackbar = true
            this.snackText = text
            this.snackColor = color
            this.timeout = 2000
		},
    },
    computed: {
        filteredProducts() {
            return this.$props.products.filter(item => item.Active == 1)
        }
    }
}
</script>

<style>
.gridTable table th + th { border-left:1px solid #dddddd; }
.gridTable table td + td { border-left:1px solid #dddddd; }

.completedForecast {
    background-color: white;
}
.incompleteForecast {
    background-color: red;
}
.incompleteForecast:hover {
    cursor: pointer;
}
</style>